import JsonLd from '@ecm/ui/seo/JsonLd'

type Item = {
  item: string
  name: string
  position: number
}

type BreadcrumbJsonLdProps = {
  itemListElements: Item[]
}

const BreadcrumbJsonLd = ({ itemListElements }: BreadcrumbJsonLdProps) => {
  const structuredData = {
    itemListElement: itemListElements.map(item => ({
      '@type': 'ListItem',
      item: {
        '@id': item.item,
        name: item.name,
      },
      position: item.position,
    })),
  }

  return <JsonLd type="BreadcrumbList" structuredData={structuredData} />
}

export default BreadcrumbJsonLd
